// extracted by mini-css-extract-plugin
export default {"productCarousel":"Y0-z"};